export default __webpack_public_path__ + "static/media/chevron.2a69c536.svg";